import React from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import RichText from './RichText';

const RegistrationSection = ({ registration }) => {
  if (!registration) return null;

  return (
    <div className="registration-section">
      <h3>{registration.title}</h3>
      <RichText value={registration.description} className="registration-description" />
      {registration.links?.map((link, index) => (
        <a
          key={index}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`registration-link ${index > 0 ? 'registration-link-spaced' : ''}`}
        >
          <FaExternalLinkAlt />
          {link.text}
        </a>
      ))}
    </div>
  );
};

export default RegistrationSection;
